export default "__VITE_ASSET__CIWqOvjt__"